<!--
  - Copyright (c) 2020.
  - Project: Source
  - LastModified: 2/14/20, 3:23 PM
  - Author: diengv < Giáp Văn Điện >
  - Email: diengv@ominext.com
  - File name: Modal.vue
  - File path: D:/Projects/PMS/Source/Client/vuejs/src/plugins/bulma/component/Modal.vue
  -->

<template>

</template>

<script>
  export default {
    name: 'Modal'
  }
</script>

<style scoped>

</style>
